const _VisualizationConfig = class _VisualizationConfig {
  static fromJSON(type, value) {
    const implementingClass = _VisualizationConfig.__registrations[type.toLowerCase()];
    if (implementingClass) {
      return implementingClass.fromJSON(type, value);
    }
    throw new Error(`Unable to find visualization config of type: ${type} - missing plugin?`);
  }
  // eslint-disable-next-line class-methods-use-this
  toBuilder() {
    throw new Error("Must not be called on abstract class!");
  }
  // eslint-disable-next-line class-methods-use-this
  equalsForSearch(_other) {
    return true;
  }
  static registerSubtype(type, implementingClass) {
    this.__registrations[type.toLowerCase()] = implementingClass;
  }
};
_VisualizationConfig.__registrations = {};
let VisualizationConfig = _VisualizationConfig;
export {
  VisualizationConfig as default
};
